import { createStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
//import logger from 'redux-logger'
import bundles from './bundles'

const persistConfig = {
  key: 'bundle-tracker',
  version: 0,
  storage,
  whitelist: ['bundles'],
}

const rootReducer = combineReducers({ bundles })
const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(persistedReducer, {})
const persistor = persistStore(store)

export { store, persistor }
